import { useEffect } from "react";
import Accessible from "@material-ui/icons/Accessible";
import { useBreadcrumbs } from "../../../contexts/breadcrumb";
import { usePriorityUpdate } from "../../../services/api-tansquery/priority/update";
import Form from "./form";
import { useParams } from "react-router-dom";
import { usePriorityDetails } from "../../../services/api-tansquery/priority/details";

export default function PriorityUpdate() {
    const { setBreadcrumbs } = useBreadcrumbs();
    const { id } = useParams<{ id: string }>();
    const { data: priority } = usePriorityDetails(Number(id));
    const mutation = usePriorityUpdate(Number(id));

    useEffect(() => {
        setBreadcrumbs((prev) => {
            const homeBreadcrumb = prev.find((_, index) => index === 0);
            return [
                homeBreadcrumb,
                {
                    label: "Prioridades",
                    path: "/prioridades",
                    icon: Accessible,
                },
                {
                    label: "Gerenciar",
                    path: "",
                },
            ];
        });
    }, [setBreadcrumbs]);

    return (
        <Form
            priority={priority}
            mutation={mutation}
        />
    );
}